import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';


@Component({
    selector: 'app-edit-role-confirmation',
    templateUrl: './edit-role-confirmation.component.html',
    styleUrls: ['./edit-role-confirmation.component.scss'],
    imports: [BaseIndexModule, ReactiveFormsModule, FormsModule]
})
export class EditRoleConfirmationComponent implements OnInit {
  editRoleChanges: EditRoleConfirmationDto = {};
  randomNum: number;
  typingText: string;

  constructor(
    private dialogRef: MatDialogRef<EditRoleConfirmationComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: EditRoleConfirmationDto
  ) {
    this.editRoleChanges = data;
  }

  ngOnInit(): void {
    this.randomNum = Math.floor(1000 + Math.random() * 9000);
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSubmit() {
    if (+this.typingText != this.randomNum) return;
    this.dialogRef.close(true);
  }
}

export class EditRoleConfirmationDto {
  deletedOrganizationNames?: string[];
  deletedOrganizationCount?: number;
  deletedClaimsCount?: number;
  roleName?: string;
}
